import React from 'react';
import MetaContent from '../../components/shared/HelmetHeader/HelmetHeader';
import { awardsInfo } from '../../utils/awardsInfo';
import BOWPage from './containers';

const { bow } = awardsInfo();
const BestOfWeddings = () => (
	<>
		<MetaContent
			landingPage="bow"
			title={`${bow.year} Wedding Awards - Best of Weddings Winners`}
			description={`The Knot Best of Weddings is an annual wedding industry award that recognizes the top wedding vendors across the country. Search ${bow.year} winners and find the best wedding professionals in your area.`}
		/>
		<BOWPage />
	</>
);

export default BestOfWeddings;
